import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import {
  PlaybooksBoard,
  PLAYBOOK_STATUS_TAB_VALUES,
  type PlaybookStatusTab,
} from '@/features/playbooks/components/PlaybooksBoard';

function parseStatusTab(value: unknown): PlaybookStatusTab {
  if (
    typeof value === 'string' &&
    (PLAYBOOK_STATUS_TAB_VALUES as readonly string[]).includes(value)
  ) {
    return value as PlaybookStatusTab;
  }
  return 'in_progress';
}

export const Route = createFileRoute('/_authenticated/playbooks/')({
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  validateSearch: (search: Record<string, unknown>) => ({
    status: parseStatusTab(search.status),
  }),
  component: PlaybooksIndexPage,
});

function PlaybooksIndexPage() {
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_VIEW}>
      <PlaybooksBoard />
    </PermissionGate>
  );
}
